var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAttendCheckToday = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  x: 1,
  y: 1,
  fill: "#fff",
  stroke: "#006EFF",
  strokeDasharray: "3 3",
  strokeWidth: 2,
  rx: 11
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#006EFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 12.025 10.985 15 16 10"
})));
export default SvgIconAttendCheckToday;